<template>
	<div ref="idThumPan" style="float:left; position:relative; width:253px; height:253px; border:0px solid red;">
		<div ref="idThum" style="float:left; border:0px solid red;"></div>
	</div>
</template>

<script>

export default {
	name: 'TPThum',
	components:{

	},
	props:['item'],
	data () {
		return {
		}
	},
	mounted: function(){
		let el=this.$refs["idThum"];
		let w1=this.item.width;
		let h1=this.item.height;
		let w=0;
		let h=0;
		let rate=w1/h1;
		if( h1 <= w1 )   // 横向
		{
			w = 240;
			h = w * h1 / w1;
			el.style["width"]  = (w)+"px";
			el.style["height"] = (h)+"px";

		}
		else             // 纵向
		{
			//h = 250;
			h = 240;
			w = h * w1 / h1;
			el.style["width"]  = (w)+"px";
			el.style["height"] = (h)+"px";
		}

		el.style["margin-left"] = ((240-w)/2+7)+"px";
		el.style["margin-top"] = ((240-h)/2+7)+"px";
		//el.style["border-top"]    = "1px solid #bbbbbb";
		//el.style["border-bottom"] = "1px solid #bbbbbb";

		el.style["background"] = "url("+this.item.templateIcon+")";
		el.style["background-size"] = "100% 100%";
		//el.style["background-repeat"] = "no-repeat";
	},
	computed:{

	},
	methods:{

	}
}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// TPThum.vue?6783d295